import React, { useRef } from 'react';
import { useViewportAnalytics } from "../../../hooks/useViewportAnalytics";
export var withAnalyticsOnBlockView = function withAnalyticsOnBlockView(ContentBlock) {
  return function (props) {
    var ref = useRef(null);
    useViewportAnalytics(ref, props.analyticBlockTitle, props.pageType);
    return /*#__PURE__*/React.createElement("section", {
      ref: ref,
      "data-t-id": "hoc-withAnalyticsOnView"
    }, /*#__PURE__*/React.createElement(ContentBlock, props));
  };
};